"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AppointmentCancelContainer = _interopRequireDefault(require("./AppointmentCancelContainer"));
var _default = exports.default = _AppointmentCancelContainer.default;